import { FaNodeJs, FaJava, FaCode, FaReacteurope } from "react-icons/fa";

import {
  SiJavascript,
  SiReact,
  SiTailwindcss,
  SiFigma,
  SiMongodb,
  SiMysql,
  SiTypescript,
  SiGithub,
  SiWordpress,
  SiFirebase,
  SiDocker,
  SiExpress,
  SiGooglecloud,
  SiAdobepremierepro,
  SiCanva,
  SiAndroid,
  SiGoogleadsense,
  SiGoogleadmob,
  SiRedux,
  SiBootstrap,
  SiGit,
  SiPostman,
  SiHtml5,
  SiCss3
} from "react-icons/si";

export const TechstackList = [
  // Frontend Technologies
  { _id: 1, name: "HTML", icon: SiHtml5, category: "frontend" },
  { _id: 2, name: "CSS", icon: SiCss3, category: "frontend" },
  { _id: 3, name: "JavaScript", icon: SiJavascript, category: "frontend" },
  { _id: 4, name: "TypeScript", icon: SiTypescript, category: "frontend" },
  { _id: 5, name: "React.js", icon: SiReact, category: "frontend" },
  { _id: 6, name: "Redux", icon: SiRedux, category: "frontend" },
  { _id: 7, name: "Tailwind CSS", icon: SiTailwindcss, category: "frontend" },
  { _id: 8, name: "Bootstrap", icon: SiBootstrap, category: "frontend" },

  // Mobile & Cloud
  { _id: 9, name: "React Native", icon: FaReacteurope, category: "mobile" },
  { _id: 10, name: "Firebase", icon: SiFirebase, category: "mobile" },
  { _id: 11, name: "Android Development", icon: SiAndroid, category: "mobile" },
  { _id: 12, name: "Google Cloud", icon: SiGooglecloud, category: "mobile" },

  // Backend & Database
  { _id: 13, name: "Node.js", icon: FaNodeJs, category: "backend" },
  { _id: 14, name: "Express.js", icon: SiExpress, category: "backend" },
  { _id: 15, name: "MongoDB", icon: SiMongodb, category: "backend" },
  { _id: 16, name: "SQL / MySQL", icon: SiMysql, category: "backend" },

  // Programming Languages
  { _id: 17, name: "Java", icon: FaJava, category: "language" },
  { _id: 18, name: "OOP (Object Oriented Programming)", icon: FaCode, category: "language" },

  // Tools & DevOps
  { _id: 19, name: "Git", icon: SiGit, category: "tools" },
  { _id: 20, name: "GitHub", icon: SiGithub, category: "tools" },
  { _id: 21, name: "Docker", icon: SiDocker, category: "tools" },
  { _id: 22, name: "Postman", icon: SiPostman, category: "tools" },
  { _id: 23, name: "WordPress", icon: SiWordpress, category: "tools" },

  // Design & Media
  { _id: 24, name: "Figma", icon: SiFigma, category: "design" },
  { _id: 25, name: "Adobe Premiere Pro", icon: SiAdobepremierepro, category: "design" },
  { _id: 26, name: "Canva", icon: SiCanva, category: "design" },

  // Marketing & Monetization
  { _id: 27, name: "Google AdSense", icon: SiGoogleadsense, category: "marketing" },
  { _id: 28, name: "AdMob", icon: SiGoogleadmob, category: "marketing" },

  // Soft Skills
  { _id: 29, name: "Leadership", icon: FaCode, category: "soft-skills" },
  { _id: 30, name: "Teamwork", icon: FaCode, category: "soft-skills" },
];
